import Vue from 'vue';
import approveDashboardUrls from '../../../urls/approveDashboardUrls';
import { ApprovalAppStatus } from '../models/approvalAppStatus.enum';

export const storePrefix = "approve_dashboard_store_";

const state = {

    sessionStorageKey: "ss_ApproveDashboard",

    approveDashboardApps: null,

    activeTab: ApprovalAppStatus.PENDING,
}

const getters = {

    approveDashboardApps(state) {
        return state.approveDashboardApps;
    },

    activeTab(state) {
        return state.activeTab;
    },
}

const mutations = {
    [`${storePrefix}setApproveDashboardApps`](state, payload) {
        state.approveDashboardApps = payload;
    },

    [`${storePrefix}setActiveTab`](state, payload) {
        state.activeTab = payload;
    },
}

const actions = {

    fetchApproveDashboardApps(context, cardId) {
        return new Promise((resolve, reject) => {

            var request = {
            };

            Vue.$http.post(approveDashboardUrls.getApprovalDashboardApps, request).then((response) => {
                context.commit(`${storePrefix}setApproveDashboardApps`, response.data);
                resolve();
            }).catch((error) => {
                reject();
            }).finally(() => {
                if (cardId) {
                    document.querySelector('#' + cardId + ' .loader').classList.remove('visible');
                }
            });

        });

    },

    updateApproveDashboardAppStatus(context, request) {
        return new Promise((resolve, reject) => {

            Vue.$http.post(approveDashboardUrls.updateApprovalDashboardAppStatus, request).then((response) => {
                console.log('update status dashbaorad apps response');
                console.log(response);
                console.log('update status dashbaorad apps response');
                context.dispatch(`fetchApproveDashboardApps`, request.cardId);
                resolve();

            }).catch((error) => {
                reject();
            });

        });

    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/ApproveDashboard/store/approveDashboard.js